import { ResourceUtility } from "./resource.js";
import { insert } from "../../service/insert.js";
import { lookup } from "../../service/lookup.js";
import { TemplateUtility } from "./template.js";
import { remove } from "@acng/frontend-bounty";
import { REGISTRY_ELEMENT, RESOURCE_LOADER } from "../resource.js";
import { FeatureUtility } from "./feature.js";
import { find } from "../../service/find.js";
/**
 * @typedef {import("../resource.js").ResourceElement} ResourceElement
 */
/**
 * The `NamespaceElement` is a {@link ResourceElement} container.
 * Because it is also a {@link ResourceElement}, it forms the basic building block
 * for the recursive registry.
 *
 * @typedef {ResourceElement} NamespaceElement
 */
export class NamespaceUtility extends ResourceUtility {
    /**
     * @param {import("../resource.js").ResourceLoader | null} loader
     */
    setLoader(loader) {
        if (!loader) {
            delete this[REGISTRY_ELEMENT][RESOURCE_LOADER];
            return;
        }
        this[REGISTRY_ELEMENT][RESOURCE_LOADER] = loader;
    }
    /**
     * @param {Document | HTMLElement | Object} item
     * @param {string} id
     * @param {string[]} path
     */
    insert(item, id, ...path) {
        return insert(this[REGISTRY_ELEMENT], item, [id, ...path]);
    }
    /**
     * @param {string[]} path
     * @returns {Promise<HTMLTemplateElement>}
     *
     * @throws {TypeError} when an element other than HTMLTemplateElement is detected. (only in debug-mode)
     * @throws {ReferenceError} when not found after fetch.
     * @throws {HTMLTemplateElement} when the namespace is hidden.
     * @throws {any} what the loader throws
     */
    lookup(...path) {
        return lookup(this[REGISTRY_ELEMENT], path);
    }
    /**
     * @param {string[]} path
     * @todo TODO(bug) when a fetch is running in the background it will not be skipped
     */
    remove(...path) {
        remove(find(this[REGISTRY_ELEMENT], path));
    }
    /**
     * @param {string[]} path
     *
     * @throws {any} See {@link NamespaceUtility.lookup}
     */
    async template(...path) {
        return new TemplateUtility(await lookup(this[REGISTRY_ELEMENT], path));
    }
    /**
     * @param {string[]} path
     */
    namespace(...path) {
        return new NamespaceUtility(this[REGISTRY_ELEMENT], ...path);
    }
    /**
     * @param {string[]} path
     * @returns {FeatureUtility}
     */
    feature(...path) {
        return new FeatureUtility(this[REGISTRY_ELEMENT], ...path);
    }
    /**
     * Remove all content.
     */
    clear() {
        const fragment = this[REGISTRY_ELEMENT].content;
        while (fragment.firstChild) {
            fragment.removeChild(fragment.firstChild);
        }
    }
}
